import React, { useState } from 'react'

import SliderStyled from 'src/pages/Aboutus/components/Slider/Slider'

import CardItemSlider from '../Slider/components/CardItemSlider'

import {
  StatsContainer,
  StatsGrid,
  StatItem,
  StatNumber,
  StatLabel,
  LogosContainer,
} from './styles'

const statsData = [
  { number: '+450', label: 'Constructoras confían en nosotros' },
  { number: '$150M', label: 'Millones en cotizaciones' },
  { number: '+3.5K', label: 'Entregas exitosas' },
]

const Information = () => {
  const [isPaused, setIsPaused] = useState(false)

  const allLogos = Array.from({ length: 24 }, (_, i) => `/images/clients/im${i}.svg`)
  const logosData = allLogos.slice(0, 9)

  return (
    <StatsContainer>
      <StatsGrid>
        {statsData.map((stat, index) => (
          <StatItem key={index}>
            <StatNumber>{stat.number}</StatNumber>
            <StatLabel>{stat.label}</StatLabel>
          </StatItem>
        ))}
      </StatsGrid>
      <LogosContainer>
        <span>Nos respalda</span>
        <SliderStyled isPaused={isPaused}>
          {logosData.map((src, idx) => (
            <CardItemSlider key={idx} logoSrc={src} setIsPaused={setIsPaused} />
          ))}
          {logosData.map((src, idx) => (
            <CardItemSlider key={`${idx}-copy`} logoSrc={src} setIsPaused={setIsPaused} />
          ))}
        </SliderStyled>
      </LogosContainer>
    </StatsContainer>
  )
}

export default Information
